import { createContext } from 'react'

export const EmailProfileContext = createContext()
